import { createFileRoute, redirect } from '@tanstack/react-router';

import { questionnaireQueries } from '@repo/api/claim/questionnaire';
import {
	BQForm,
	isValidPage,
	Page,
} from '@repo/features/businessQuestionnaire';

import { Route as BusinessRoute } from '../_claim/business';
import { Route as DocumentsRoute } from '../_claim/documents';

export const Route = createFileRoute(
	'/_claims/claim/$claimId/(questionnaire)/business/$page',
)({
	beforeLoad: ({ params, context }) => {
		const { claimId, page } = params;

		if (
			!context.user?.permissions.includes('claim.questionnaire.complete') &&
			!context.user?.permissions.includes('claim.questionnaire.edit')
		) {
			throw redirect({
				to: '/',
			});
		}

		if (!isValidPage(page)) {
			throw redirect({
				to: Route.to,
				params: {
					claimId,
					page: 'details',
				},
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.ensureQueryData(
			questionnaireQueries.id(params.claimId),
		);
	},
	component: function QuestionnairePage() {
		const { page: pageParam, claimId } = Route.useParams();

		const page: Page = isValidPage(pageParam) ? pageParam : 'details';

		const navigate = Route.useNavigate();

		const navigateToPage = async (targetPage?: Page, scrollKey?: string) => {
			if (targetPage && page !== targetPage) {
				await navigate({
					to: Route.to,
					params: (params) => ({
						...params,
						page: targetPage,
					}),
				});
			}

			if (scrollKey) {
				document.getElementById(scrollKey)?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			}
		};

		return (
			<BQForm
				page={page}
				claimId={claimId}
				navigateToPage={navigateToPage}
				exit={(source?: 'submit' | 'save') =>
					navigate({
						to: source === 'submit' ? DocumentsRoute.to : BusinessRoute.to,
					})
				}
			/>
		);
	},
	head: (ctx) => ctx.match.context.setTitle('Claim', 'Questionnaire'),
});
